// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs-module--wrapper--28cFS","tabs":"Tabs-module--tabs--1of6Y"};